import { useEffect, useState } from "react";
import { Alert, Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Row } from "react-bootstrap";
import { TrashBinOutline, WarningOutline } from 'react-ionicons';
import { useParams } from "react-router-dom";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useWebSocket } from "../../providers/WebSocketProvider";

import Api from "../../utils/api";
import ButtonSave from "../components/ButtonSave";
import SourceOutput from "./SourceOutput";
import SourceState from "./SourceState";


const SourceDetails = () => {

    const { id } = useParams();

    const [source, setSource] = useState(null);
    const [profiles, setProfiles] = useState([]);
    const [changes, setChanges] = useState(false);
    const [outputChanges, setOutputChanges] = useState(false);
    const [buttonStatus, setButtonStatus] = useState(0);

    const [showEmptyOutputsWarning, setShowEmptyOutputsWarning] = useState(false);

    const sockets = useWebSocket()


    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (source) {
            setShowEmptyOutputsWarning(source.outputs.length === 0)
        }
    }, [source]);


    useEffect(() => {

        if (sockets && sockets.length > 0) {

            sockets.forEach(socketObj => {
                if (socketObj.listenerReady) {
                    return
                }

                socketObj.socket.addEventListener('message', (event) => {
                    const json = JSON.parse(event.data)

                    if (json.id !== parseInt(id)) {
                        return
                    }

                    switch (json.action) {
                        case 'start':
                            updateSourceState(1)
                            break;
                        case 'starting':
                            updateSourceState(3)
                            break;
                        case 'fail':
                            updateSourceState(4)
                            break;
                        case 'stop':
                            updateSourceState(0)
                            break;
                        default:
                            break;
                    }
                });
            });
        }
    }, [sockets]);



    const fetchData = async () => {
        try {
            const data1 = await Api.get('/profiles')
            setProfiles(data1)

            const data = await Api.get('/streams/' + id);
            setSource(data);

        } catch (error) {
            console.error('Error al obtener los datos:', error);
        }
    };

    const save = async () => {
        setButtonStatus(2)
        const toSave = (({ id, name, url, urlBackup, status }) => ({ id, name, url, urlBackup, status }))(source);

        await Api.post('/streams/' + id, toSave)
        setButtonStatus(3)
        setOutputChanges(true)
    };

    const restart = async () => {

        const server = Api.servers.find(item => item.id === source.server);
        if (sockets && server) {
            const payload = {
                action: 'restart',
                id: id
            };

            const socketObj = sockets.find(item => item.id === server.id);
            socketObj.socket.send(JSON.stringify(payload))
            setOutputChanges(false)
        }

    }

    const handleAddOutput = (index) => {
        // Crear un nuevo objeto manteniendo las otras propiedades y actualizando "outputs"

        const emptyOutput = {
            id: 0,
            name: source.name,
            map: '',
            profileId: 1,
            isBackup: false,
            status: true
        }

        const nuevoObjeto = {
            ...source,
            outputs: [...source.outputs, emptyOutput]
        };

        setSource(nuevoObjeto);
    }

    const handleDelete = (index) => {
        const newArray = [...source.outputs];
        newArray.splice(index, 1);

        setSource((state) => ({
            ...state,
            'outputs': newArray,
        }));
    };

    const updateSource = (event) => {
        let { name, value } = event.target;

        if (name === 'isBackup' || name === 'status') {
            value = value === '1' ? true : false
        }

        if (name === 'headers') {
            value = value.split('\n');
        }

        setSource((state) => ({
            ...state,
            [name]: value,
        }));

        setButtonStatus(1)
        setChanges(true)
    };


    const updateSourceState = (newValue) => {
        setSource((state) => ({
            ...state,
            state: newValue,
        }));
    };




    if (source === null) {
        return (
            <>Cargando...</>
        )
    }


    return (
        <>

            {outputChanges &&
                <Alert variant="warning" className="mt-5" onClose={() => setChanges(false)} dismissible>
                    <WarningOutline color={'#d2a137'} width="28px" height="28px" beat />
                    <span className="ms-2">Se actualizaron las salidas, reinicie para actualizar</span>
                    <div className="mt-2">
                        <Button onClick={restart} variant="outline-warning">
                            Aplicar cambios
                        </Button>
                    </div>
                </Alert>
            }

            {showEmptyOutputsWarning &&
                <Alert variant="danger" className="mt-5" onClose={() => setChanges(false)} dismissible>
                    <WarningOutline color={'red'} width="28px" height="28px" beat />
                    <span className="ms-2">No hay ninguna salida, se desactivara esta fuente</span>
                </Alert>
            }


            <Row className={changes || showEmptyOutputsWarning ? "mt-3" : "mt-4"}>
                <Col><h3>{source.name}</h3></Col>
                <Col className="text-end"><h5><SourceState state={source.state} size={14} /></h5></Col>
            </Row>



            <Form className="mt-3">
                <Card>
                    <CardHeader>
                        <Row className="justify-content-between">
                            <Col>
                                Datos
                            </Col>
                            <Col className="text-end" title="Eliminar">
                                <TrashBinOutline color={'#fff'} style={{ cursor: 'pointer' }} />
                            </Col>
                        </Row>
                    </CardHeader>

                    <CardBody>

                        <Row className="row mb-3">
                            <Col md={8}>
                                <FormGroup>
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control name="name" defaultValue={source.name} onChange={updateSource} />
                                </FormGroup>

                                <FormGroup className="mt-2">
                                    <Form.Label>URL</Form.Label>
                                    <Form.Control name="url" defaultValue={source.url} onChange={updateSource} />
                                </FormGroup>

                                <FormGroup className="mt-2">
                                    <Form.Label>URL Backup</Form.Label>
                                    <Form.Control name="urlBackup" defaultValue={source.urlBackup} onChange={updateSource} />
                                </FormGroup>

                                <FormGroup className="mt-2">
                                    <Form.Label>Headers</Form.Label>
                                    <Form.Control as="textarea" rows={3} name="headers" defaultValue={source.headers ? source.headers.join('\n') : ''} onChange={updateSource} />
                                </FormGroup>
                            </Col>
                            <Col md={3} offset={1}>
                                <FormGroup>
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select name="status" defaultValue={source.status ? '1' : '0'} onChange={updateSource}>
                                        <option value="1">Activado</option>
                                        <option value="0">Desactivado</option>
                                    </Form.Select>
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="text-end mt-3">
                            <ButtonSave onClick={save} status={buttonStatus} setStatus={setButtonStatus} />
                        </div>

                    </CardBody>
                </Card>

                <div className="text-end mt-4">
                    <Button variant="info" onClick={handleAddOutput}>Agregar salida</Button>
                </div>


                <TransitionGroup>
                    {source.outputs.map((item, index) =>
                        <CSSTransition key={index} timeout={500} classNames="fade">
                            <SourceOutput
                                key={index}
                                item={item}
                                sourceId={source.id}
                                profiles={profiles}
                                onUpdates={() => { setOutputChanges(true) }}
                                onDelete={() => handleDelete(index)}
                            />
                        </CSSTransition>
                    )}

                </TransitionGroup>

            </Form>
        </>
    );
}

export default SourceDetails;